const _ = importLib('lodash');
const M = importLib('moment');
// const Vuex = importLib('Vuex');
const getHelpers = importLib('getHelpers');

const api = getHelpers('api');
const getImagePath = getHelpers('getImagePath');
const getAssetPath = getHelpers('getAssetPath');
const formatString = getHelpers('formatString');

_.mixin({
    imgPath: getImagePath,
    filePath: getAssetPath,
    str: formatString,
});

export default {
    computed: {
        _() {
            return _;
        },

        api() {
            return api;
        },
    },

    methods: {
        __(value, format = null) {
            return formatString(value, format);
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/components/UtilsMixin.js